import { render, staticRenderFns } from "./MobileUserNavigation.vue?vue&type=template&id=49da28a9"
import script from "./MobileUserNavigation.vue?vue&type=script&lang=js"
export * from "./MobileUserNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports